import React from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import { CommonProperties } from '../../styles';
import TripSummayList from './TripSummayList';

const ChangeTripList = ({ response, airResponse, onChange }) => {
  return (
    <ScrollView style={styles.container}>
      <TripSummayList
        pnr={response?.PNR}
        change={onChange}
        passengers={response?.Passengers}
        railList={response?.RailResponseDetails}
        airList={airResponse}
        hotelList={response?.HotelResponseDetails}
        carList={response?.CarResponseDetails}
      />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    ...CommonProperties.p3,
  },
});

export default ChangeTripList;
